import Vue from 'vue';
import VueRouter from 'vue-router';
import About_Us from '../page/About_Us.vue';
import Contact from '../page/Contact.vue';
import Group_Business from '../page/Group_Business.vue';
import index from '../page/index.vue';
import Legitimate from '../page/Legitimate.vue';
import Policy from '../page/Policy.vue';
import PolicyDPF from '../page/PolicyPDF.vue';
import Publisher from '../page/Publisher.vue';
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

let router = new VueRouter({
  mode: 'history',
  routes: [
    // { path: "/", redirect: "/index" },
    { path: '*', redirect: '/', hidden: true },
    { path: '/', component: index, name: index },
    { path: '/Publisher', component: Publisher, name: Publisher },
    { path: '/About_Us', component: About_Us, name: About_Us },
    { path: '/Group_Business', component: Group_Business, name: Group_Business },
    { path: '/Contact', component: Contact, name: Contact },
    { path: '/Policy', component: Policy, name: Policy },
    { path: '/PolicyDPF', component: PolicyDPF, name: PolicyDPF },
    { path: '/lic', component: Legitimate, name: Legitimate },
  ],
});

export default router;
